const ActiveItemIdentityMatchesDetails = ({item}) => {
  return (
    <ul className="card-details__craft-sublist">
      <li className="card-details__craft-sublist-item-owned">
        <p>
          <span className="card-details__craft-sublist-item-value">Identities owned</span>
          <span className="card-details__craft-sublist-item-status">{item.identity_owned}</span>
        </p>
      </li>
      <li>
        <p className="card-details__craft-sublist-item">
        <span className="card-details__craft-sublist-item-value">{item.birth_month.name}</span>
        <span className="card-details__craft-sublist-item-status">{item.birth_month.status}</span>
        </p>
      </li>
      <li className="card-details__craft-sublist-item">
        <span className="card-details__craft-sublist-item-value">{item.birth_day.name}</span>
        <span className="card-details__craft-sublist-item-status">{item.birth_day.status}</span>
      </li>
      <li className="card-details__craft-sublist-item">
        <span className="card-details__craft-sublist-item-value">{item.birth_year.name}</span>
        <span className="card-details__craft-sublist-item-status">{item.birth_year.status}</span>
      </li>
      <li className="card-details__craft-sublist-item">
        <span className="card-details__craft-sublist-item-value">{item.category.name}</span>
        <span className="card-details__craft-sublist-item-status">{item.category.status}</span>
      </li>
    </ul>
  )
}

export default ActiveItemIdentityMatchesDetails;
